import { queryClient } from "@lib/queryClient";

import type { AllRouteEndpoints } from "../routeTypes";
import { getInvalidateCacheKeys } from "./getInvalidationCacheKeys";

/**
 * Invalidate every cached query belonging to the given endpoints.
 *
 * Always go through this rather than handing the result of `getInvalidateCacheKeys` straight to
 * `queryClient.invalidateQueries`: react-query reads an array argument as one composite query key and
 * matches it element-wise, so passing several cache keys at once silently matches nothing. Each key
 * has to be invalidated on its own.
 *
 * Duplicates are dropped first, because invalidating the same cache key twice in one tick cancels the
 * first refetch and issues a second request for the same data.
 * @param invalidationQueryKeys one endpoint, or the list of endpoints whose caches should go stale
 */
export const invalidateCacheKeys = (invalidationQueryKeys: AllRouteEndpoints | AllRouteEndpoints[]) => {
  const keysByCacheKey = new Map(getInvalidateCacheKeys(invalidationQueryKeys).map((key) => [key.cacheKey, key]));
  keysByCacheKey.forEach((key) => queryClient.invalidateQueries([key]));
};
